import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Lock } from "lucide-react";

const AUTH_URL = "https://auth.emergentagent.com/";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState(null); // null = checking, true = allowed, false = denied
  const [err, setErr] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const e = params.get("autherror");
    if (e) setErr(e);
    api.get("/auth/me").then(() => setState(true)).catch(() => setState(false));
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `${AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (state === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-background">
        <p className="text-white/50 uppercase tracking-[0.25em] text-sm">Checking access…</p>
      </div>
    );
  }

  if (state === false) {
    return (
      <div data-testid="admin-login" className="min-h-[70vh] flex flex-col items-center justify-center bg-background px-6 text-center">
        <Lock className="w-10 h-10 text-primary mb-6" />
        <h1 className="font-anton text-4xl sm:text-5xl uppercase text-white">Admin Access</h1>
        <p className="text-white/50 mt-3 max-w-sm">
          Sign in with your authorized Google account to manage the store.
        </p>
        {err && <p data-testid="auth-error" className="text-red-500 text-sm mt-4 max-w-sm">{err}</p>}
        <button
          data-testid="google-login-button"
          onClick={login}
          className="mt-8 bg-primary text-black hover:bg-white px-8 py-4 font-bold uppercase tracking-[0.2em] text-sm transition-colors active:scale-95"
        >
          Sign in with Google
        </button>
      </div>
    );
  }

  return children;
}
